import { Component, OnInit } from '@angular/core';
import { TramiteAfiliado } from '../_models/tramite-afiliado.model';
import {ActivatedRoute } from "@angular/router";
import { ProfileService } from '../_services/profiles.service';
import { AuthenticationService } from '../_services/authentication.service';
import { Profile } from '../_models/profile.model';
import { User } from '../_models/user.model';
import { Subscription } from 'rxjs';
import { TramiteHistorial } from '../_models/tramite-historial';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent implements OnInit {
  tramite: TramiteAfiliado;
  currentProfile: Profile;
  currentUser: User;
  profileSubscription: Subscription;
  public isCollapsed = false;
  
  constructor(private activatedRoute: ActivatedRoute,
    private profilesService: ProfileService,
    private authenticationService: AuthenticationService
     ) { 
    
    this.tramite = JSON.parse(activatedRoute.snapshot.params["tramite"]);
    //this.historias = JSON.parse(activatedRoute.snapshot.params["tramite"]);
    let fecha = new Date(this.tramite.fecha);
    this.tramite.fecha = fecha;
  }

  ngOnInit() {
    this.currentProfile = this.profilesService.getSelectedProfile();
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      (profile: Profile) => {
        this.currentProfile = profile;
        this.currentUser = this.authenticationService.currentUserValue;
      }
    );
    
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

}


